<template>
    <div class="modal warning fade" :class="{ 'is-open': open }">
      <div class="modal-dialog" style="top:30%;">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">高齡投保評估量表</h3>
          </div>
          <div class="modal-body">
            <br />
            <span class="text-style">
              為符合法令規範，保險年齡達65(含)歲以上之要保人、被保險人或繳款人是否有辨識不利其投保權益情形之能力及保險商品適合性，請確實詢問客戶填寫。
            </span>
            <br />
            <span class="text-style">
              (「高齡投保評估量表」如有問題，可於上班時間撥打業務員諮詢專線，撥號路徑：國泰員工入口網站／業務聯繫通訊錄／關鍵字輸入『e0600』／點『網路電話』／轉6或撥打市話(02)2162-1127。)
            </span>
          </div>
          <div class="modal-footer">
            <div class="text-right">
              <button type="button" @click="doCancel()" class="btn btn-default">取消</button>
              <button type="button" @click="doSubmit()" :disabled="!isDataComplete" class="btn btn-primary">前往填寫</button>
            </div>
          </div>
        </div>
      </div>
      <!--開啟連結用表單-->
      <div>
        <form v-show="false" name="form_A" :action="linkUrl" method="post" target="_blank" accept-charset="big5" onsubmit="document.charset='big5'">
          <input name="ID" v-if="id" :value="id" type="hidden" /><!--id非必填-->
          <input name="NAME" :value="name" type="hidden" />
          <input name="BIRTHDAY" v-if="birthday" :value="birthday" type="hidden" /><!--生日非必填-->
          <input name="SRC" :value="'CRM'" type="hidden" />
          <button type="submit" id="submitForEldEvaluation"></button>
        </form>
      </div>
    </div>
</template>

<script>
import { commonMixin } from '@/mixins/common';
export default {
  name: "EldEvaluationFormModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    birthday: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      linkUrl: "",
    };
  },
  computed: {
    isDataComplete() {
      return this.name;
    },
  },
  methods: {
    doCancel() {
      this.$emit("close");
    },
    doSubmit() {
      if (this.isWebView()) {
        let param = "";
        let id = this.id || "";
        let name = this.name || "";
        let birthday = this.birthday || "";
        let src = "CRM";
        param += "ID=" + id;
        param += "&NAME=" + encodeURIComponent(name);
        param += "&BIRTHDAY=" + birthday;
        param += "&SRC=" + src;
        this.boxOpenSurvey(this.linkUrl + "?" + param);
      } else {
        document.querySelector("#submitForEldEvaluation").click();
      }
    },
  },
  mounted() {
    // 設定動態 url
    let href = window.location.href;
    let netzone = "https://twas3.";
    if (href.indexOf("tmycrm") !== -1) {
      netzone = "https://twas3.";
    } else if (href.indexOf("smycrm") !== -1) {
      netzone = "https://swas3.";
    } else if (href.indexOf("mycrm") !== -1) {
      netzone = "https://was2.";
    }
    this.linkUrl =
      netzone +
      "cathaylife.com.tw/ATWeb/servlet/HttpDispatcher/ATA0_4800/prompt";
  },
};
</script>

<style scoped>
.text-style {
  font-family: PingFangTC;
  font-size: 20px;
  font-weight: bolder;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #323a45;
}
</style>